<template>
  <div class="xiaobu-container" v-closeSelect="'window'">
    <el-form ref="queryForm" :model="queryParams" :inline="true" class="search-form clearfix">
      <el-form-item class="search-field fl five-per-row" label="盘库单号" prop="checkNo">
        <el-input v-model.trim="queryParams.checkNo" placeholder="请输入盘库单号" clearable
          @keyup.enter.native="handleQuery" />
      </el-form-item>

      <el-form-item class="search-field fl five-per-row" label="盘点仓库" prop="checkWareHouseId">
        <el-cascader aria-hidden="false" :options="wareHouseData" clearable :props="defaultProps"
          v-model="queryParams.checkWareHouseId" @change="handleQuery" placeholder="请选择盘点仓库" />
      </el-form-item>
      <el-form-item class="search-field fl five-per-row" label="盘库状态" prop="checkStatus">
        <el-select-dict dictType="CHECK_STATUS" clearable placeholder="请选择盘库状态" v-model="queryParams.checkStatus"
          @dictChange="handleQuery"></el-select-dict>
      </el-form-item>

      <el-form-item class="search-field fl" label="渠道" prop="channel">
        <el-select-dict dictType="CHANNEL" clearable placeholder="请选择渠道" v-model="queryParams.channel"
          @change="handleQuery"></el-select-dict>
      </el-form-item>
      <el-form-item class="search-field fl five-per-row" label="创建时间" prop="beginTime">
        <el-date-picker v-model="dateRange" value-format="yyyy-MM-dd HH:mm:ss" type="daterange" @change="handleQuery"
          range-separator="-" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
      </el-form-item>

      <el-form-item class="fr">
        <el-button plain @click="resetQuery">重 置</el-button>
        <el-button type="primary" @click="handleQuery">查 询</el-button>
      </el-form-item>
    </el-form>
    <div class="table-wrap">
      <div class="table-control-box">
        <el-button v-hasPermission="['inventory:check:create']" type="primary" plain icon="el-icon-plus" size="mini"
          @click="handleAdd">新增</el-button>
        <el-button v-hasPermission="['inventory:check:update']" type="success" plain icon="el-icon-edit" size="mini"
          :disabled="single" @click="handleUpdate">编辑</el-button>
        <el-button v-hasPermission="['inventory:check:delete']" type="danger" plain icon="el-icon-delete" size="mini"
          :disabled="multiple" @click="handleBatchDelete">删除</el-button>
      </div>
      <div class="table-box">
        <auto-height-table ref="checkTable" :class="{ empty: list.length === 0 }" empty-text=" " v-loading="loading" :data="list"
          row-key="checkId" @selection-change="handleSelectionChange" @row-click="clickRow">
          <el-table-column type="selection" :selectable="checkSelectable" :reserve-selection="true" width="55"
            align="center" />
          <el-table-column label="盘库单号" prop="checkNo" align="center" min-width="172px">
            <template slot-scope="scope">
              <el-link v-if="mixinHasPermi(['inventory:record:list']) && scope.row.checkStatus === '1'" type="primary"
                @click="mixinHandleGoRecordList(scope.row.checkNo)">{{ scope.row.checkNo }}</el-link>
              <span v-else>{{ scope.row.checkNo }}</span>
            </template>
          </el-table-column>
          <el-table-column label="盘点仓库" prop="wareHouseName" align="center" min-width="168px">
            <template slot-scope="scope">
              {{ getWareHouseName(scope.row.checkWareHouseId) }}
            </template>
          </el-table-column>
          <el-table-column-dict dictType="CHECK_STATUS" dictTypeNode="tag" label="盘库状态" align="center"
            prop="checkStatus" min-width="100px"></el-table-column-dict>
          <el-table-column-dict dictType="CHANNEL" dictTypeNode="tag" label="渠道" align="center" prop="channel"
            min-width="100px"></el-table-column-dict>
          <el-table-column align="center" prop="profitLossNumber" label="盈亏数量" width="160px">
            <template slot-scope="scope">
              {{ scope.row.profitLossNumber | numberFilter }}
            </template>
          </el-table-column>
          <el-table-column label="操作人" prop="creator.userName" align="center" min-width="168px" show-overflow-tooltip>
            <template slot-scope="scope">
              创建人：{{ scope.row.creator.userName }}<br />
              更新人：{{ scope.row.updater.userName }}
            </template>
          </el-table-column>
          <el-table-column dateFormat="datetime" label="操作时间" align="center" prop="createTime" min-width="256px">
            <template slot-scope="scope">
              创建时间：{{ scope.row.createTime | formatDate("datetime") }}<br />
              更新时间：{{ scope.row.updateTime | formatDate("datetime") }}
            </template>
          </el-table-column>
          <el-table-column label="操作" v-if="
            mixinHasPermi([
              'inventory:check:read',
              'inventory:check:delete',
            ])
          " align="center" width="228px" fixed="right" class-name="small-padding ">
            <template slot-scope="scope">
              <el-button size="mini" v-hasPermission="['inventory:check:read']" type="primary" icon="el-icon-view"
                @click.native.stop="handleUpdate(scope.row)">查看</el-button>
              <el-button :disabled="scope.row.checkStatus === '1'" v-hasPermission="['inventory:check:read']" size="mini"
                type="danger" icon="el-icon-delete" title="已盘库的盘库单不可删除"
                @click.native.stop="handleDelete(scope.row)">删除</el-button>
            </template>
          </el-table-column>
        </auto-height-table>

        <pagination v-show="total > 0" :total="total" :page.sync="queryParams.pageNum"
          :limit.sync="queryParams.pageSize" @pagination="getList" />
      </div>
    </div>
    <check-dialog ref="checkDialog" :visible.sync="open" :modal-append-to-body="false" :close-on-click-modal="false"
      :isUpdate="isUpdate" :baseForm="baseForm" @close="open = false" @successs="init" width="1280px"
      :wareHouseData="wareHouseData"></check-dialog>
  </div>
</template>

<script>
import CheckDialog from "./components/check-dialog.vue"
import { checkApi, wareHouseApi } from "@/api"
import { getPathByTreeValue } from "vue2-element-admin-plugin"
import {markNonLeafNodes} from "@/utils/tree"

export default {
  name: "inventoryCheckManage",
  components: {
    CheckDialog
  },
  data() {
    return {
      selection: [], // 选中的列表数据
      // 非单个禁用
      single: true,
      // 非多个禁用(0个禁用)
      multiple: true,

      defaultProps: {
        checkStrictly: true,
        value: "wareHouseId",
        children: "children",
        label: "wareHouseName"
      },
      wareHouseData: [], // 仓库树 数据
      isUpdate: false, // 是否是编辑
      //搜索条件参数
      queryParams: {
        checkNo: "", // 盘库单号
        checkWareHouseId: [], // 盘点仓库
        checkStatus: "", // 配置项状态
        channel: "", // 渠道
        beginTime: "",
        endTime: "",
        pageNum: 1,
        pageSize: 10
      },
      dateRange: [],
      list: [],
      loading: false,
      total: 0,
      open: false,
      // 表单参数
      baseForm: {
        checkStatus: "", // 
        remark: "" // 备注
      }

    }
  },
  watch: {
    open(val) {
      if (!val) {
        this.isUpdate = false
        this.baseForm = {
          checkStatus: "", // 
          remark: "" // 备注
        }
        this.$refs.checkDialog && this.$refs.checkDialog.resetForm()
      }
    }
  },
  async created() {
    const { query } = this.$route
    if (query.operateNo || query.billNo) {
      this.queryParams.checkNo = query.operateNo || query.billNo
    }
    await this.init()
  },
  methods: {
    // 初始化 入库成功后得重新获取仓库数据
    async init() { 
      await this.getWareHouseTree()
      //获取列表
      this.getList()
    },
    // 已入库的 禁止操作
    checkSelectable(row, index) {
      if (row.checkStatus === "1") {
        return false
      } else {
        return true
      }
    },
    //点击行
    clickRow(row) {
      //已入库的 不做处理
      if (row.checkStatus === "1") {
        return
      }
      this.$refs.checkTable.toggleRowSelection(row)
    },
    //批量删除
    handleBatchDelete() {
      // 让按钮返回原样
      this.mixinBtnBlur()

      let str = ""
      const ids = []
      for (let i = 0; i < this.selection.length; i++) {
        const item = this.selection[i]
        ids.push(item.checkId)
        str += item.checkNo
        if (i !== this.selection.length - 1) {
          str += ", "
        }
      }
      this.$modal
        .confirm('删除后将无法找回！是否确认删除盘库单号为"【' + str + '】"的数据项？')
        .then(function() {
          return checkApi.batchDeleteItems({ ids })
        })
        .then(() => {
          this.handleQuery()
          this.$modal.msgSuccess("批量删除盘库单成功")
        })
    },
    // 多选框选中数据
    handleSelectionChange(selection) {
      this.selection = selection
      this.single = selection.length !== 1
      this.multiple = !selection.length
    },

    // 获取仓库列表
    getWareHouseTree() {
      return wareHouseApi.getWareHouseTree().then((data) => {
        this.wareHouseData = markNonLeafNodes(data, this.mixinWareHouseIdList, {idField: "wareHouseId"})
      })
    },
    // 获取仓库名字
    getWareHouseName(val) {
      const list = getPathByTreeValue(this.wareHouseData, val, { targetField: "wareHouseId", childrenField: "children" }, true)
      return list[list.length - 1].labelArr.join("/")
    },
    /** 搜索按钮操作 */
    handleQuery() {
      this.queryParams.pageNum = 1
      this.getList()
    },
    /** 重置按钮操作 */
    resetQuery() {
      this.dateRange = []
      this.mixinResetForm("queryForm")
      // 库存单号重置
      this.queryParams.checkNo = ""
      this.handleQuery()
    },
    /** 查询列表 */
    getList() {
      // 清空所有选中的数据
      this.$refs.checkTable && this.$refs.checkTable.clearSelection()
      this.loading = true
      const params = JSON.parse(JSON.stringify(this.queryParams))
      params.checkWareHouseId = (Array.isArray(params.checkWareHouseId) ? params.checkWareHouseId[params.checkWareHouseId.length - 1] : params.checkWareHouseId) || null
      checkApi
        .getList(this.mixinAddDateRange(params, this.dateRange))
        .then((response) => {
          this.list = response.rows
          this.total = response.total
          this.loading = false
        })
        .catch((err) => {
          if (err?.name === "CanceledError") {
            return
          }
          this.loading = false
        })
    },
    /** 新增按钮操作 */
    handleAdd() {
      this.open = true
    },

    /** 编辑按钮操作 */
    handleUpdate(row) {
      if (!row.checkId) {
        this.isUpdate = true
      }
      const id = row.checkId || (this.selection[0] && this.selection[0].checkId)
      checkApi.getDetailById({ id }).then((data) => {
        this.baseForm = Object.assign(this.baseForm, data)
        this.open = true
      })
    },
    /** 删除按钮操作 */
    handleDelete(row) {
      // 让按钮返回原样
      this.mixinBtnBlur()

      const id = row.checkId
      this.$modal
        .confirm('删除后将无法找回！是否确认删除盘库单号为"' + row.checkNo + '"的数据项？')
        .then(function() {
          return checkApi.deleteItem({ id })
        })
        .then(() => {
          this.handleQuery()
          // 判断删除的项是否被勾选了
          const flag = this.selection.find((item) => item.checkId === id)
          flag && this.$refs.checkTable.toggleRowSelection(row, false)
          this.$modal.msgSuccess("删除成功")
        })
    }
  }
}
</script>